/* Dress To: smoother scrolling (loaded from layout/theme.liquid).

   1. Auto-advancing slideshows (the home hero, every 3 seconds) wait while the shopper is scrolling and while
      they are off screen. Measured on the live home page: scrolling near the top while the hero changed slide
      dropped 19 frames in 9 seconds (worst frame 75 ms); with the slide change held during the scroll, none.
      The slideshow carries on about a second after scrolling stops, from where it was.
   2. Autoplaying videos only play while they can be seen: the hero loads a desktop and a phone version and both
      used to play, and they kept playing after scrolling away.
   3. Instagram feed (Instafeed app, right under the hero). This was the lag: the app plays its Instagram reels
      on its own ("one at a time"), at full resolution, and decoding that video while the page scrolls dropped about
      half the frames (221 of 406 in 9 seconds near the top of the home page, Mac/Chrome). With the reel held while
      the shopper scrolls: 2 of 1,067. The reel now pauses while scrolling and plays again about a second after
      scrolling stops, if it is on screen. Its photos (full size from Instagram, up to 3072x4095 px for 206x367 px
      tiles) are also decoded with decoding="async" so a photo still decoding doesn't hold up a frame. */
(function () {
  'use strict';
  if (window.__dtPerf || !('IntersectionObserver' in window)) return;
  window.__dtPerf = true;

  var IDLE_MS = 1200;
  var shows = [];
  var inView = new WeakMap();
  var scrolling = false;
  var idleTimer = 0;

  function canRun(show) {
    return inView.get(show) && !scrolling && !document.hidden;
  }

  function syncShow(show) {
    if (typeof show.suspend !== 'function' || typeof show.resume !== 'function') return;
    if (canRun(show)) {
      /* resume() keeps the theme's own rules: it does nothing when autoplay is off or the shopper paused it */
      if (show.dataset.dtHeld) {
        delete show.dataset.dtHeld;
        show.resume();
      }
    } else if (!show.dataset.dtHeld && !show.hasAttribute('paused')) {
      show.dataset.dtHeld = '1';
      show.suspend();
    }
  }

  function syncAll() {
    for (var i = 0; i < shows.length; i++) syncShow(shows[i]);
  }

  var showObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      inView.set(entry.target, entry.isIntersecting && entry.intersectionRatio > 0.2);
      syncShow(entry.target);
    });
  }, { threshold: [0, 0.2, 0.5] });

  var videoObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      var visible = entry.isIntersecting && entry.intersectionRatio > 0.05 && !document.hidden;
      if (visible) {
        if (video.paused && video.dataset.dtHeld) {
          delete video.dataset.dtHeld;
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
      } else if (!video.paused) {
        video.dataset.dtHeld = '1';
        video.pause();
      }
    });
  }, { threshold: [0, 0.05], rootMargin: '300px 0px' });

  /* 3. Instagram reels: no video decoding while the page scrolls */
  function isInstagramVideo(el) {
    return el && el.tagName === 'VIDEO' && !!el.closest('[class*="instafeed"]');
  }
  function onScreen(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
  }
  function holdInstagramVideos(hold) {
    document.querySelectorAll('[class*="instafeed"] video').forEach(function (v) {
      if (hold) {
        if (!v.paused) { v.dataset.dtScrollHeld = '1'; v.pause(); }
      } else if (v.dataset.dtScrollHeld) {
        delete v.dataset.dtScrollHeld;
        if (onScreen(v) && !document.hidden) {
          var p = v.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
      }
    });
  }
  /* the app starts the next reel by itself: if that happens mid-scroll, hold it until the scroll ends */
  document.addEventListener('play', function (event) {
    var v = event.target;
    if (scrolling && isInstagramVideo(v)) { v.dataset.dtScrollHeld = '1'; v.pause(); }
  }, true);

  /* Instagram photos: decode without blocking frames */
  function asyncDecode(node) {
    if (node.nodeType !== 1) return;
    if (node.tagName === 'IMG') {
      if (node.getAttribute('decoding') !== 'async') node.setAttribute('decoding', 'async');
      return;
    }
    if (node.querySelectorAll) node.querySelectorAll('img:not([decoding="async"])').forEach(function (img) { img.setAttribute('decoding', 'async'); });
  }
  function watchInstagram() {
    var roots = document.querySelectorAll('[class*="instafeed"], [id*="insta-feed"]');
    var sections = [];
    roots.forEach(function (root) {
      var section = root.closest('.shopify-section') || root;
      if (sections.indexOf(section) === -1) sections.push(section);
    });
    sections.forEach(function (section) {
      if (section.dataset.dtWatched) return;
      section.dataset.dtWatched = '1';
      asyncDecode(section);
      var mo = new MutationObserver(function (list) {
        list.forEach(function (m) { m.addedNodes.forEach(asyncDecode); });
      });
      mo.observe(section, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 60000);
    });
    return sections.length;
  }

  function scan(root) {
    (root || document).querySelectorAll('slideshow-component[autoplay]').forEach(function (show) {
      if (show.dataset.dtWatched) return;
      show.dataset.dtWatched = '1';
      shows.push(show);
      showObserver.observe(show);
    });
    (root || document).querySelectorAll('video[autoplay]').forEach(function (video) {
      if (video.dataset.dtWatched) return;
      video.dataset.dtWatched = '1';
      videoObserver.observe(video);
    });
  }

  window.addEventListener('scroll', function () {
    if (!scrolling) {
      scrolling = true;
      syncAll();
      holdInstagramVideos(true);
    }
    clearTimeout(idleTimer);
    idleTimer = setTimeout(function () {
      scrolling = false;
      syncAll();
      holdInstagramVideos(false);
    }, IDLE_MS);
  }, { passive: true });

  document.addEventListener('visibilitychange', syncAll);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });

  /* 4. Campaign end: anything marked data-dt-ends (Unix seconds: the gift note on product pages, the gift line in
        the bag) is hidden once that time has passed, also on a page that was cached or left open before then.
        The theme stops rendering them after that time too; this covers the pages it rendered earlier. */
  function hideEnded(root) {
    var now = Date.now() / 1000;
    var next = 0;
    var list = [];
    if (root.nodeType === 1 && root.hasAttribute('data-dt-ends')) list.push(root);
    if (root.querySelectorAll) list = list.concat([].slice.call(root.querySelectorAll('[data-dt-ends]')));
    list.forEach(function (el) {
      var end = +el.getAttribute('data-dt-ends');
      if (!end) return;
      if (end <= now) el.style.setProperty('display', 'none', 'important');
      else if (!next || end < next) next = end;
    });
    return next;
  }
  function watchEnds() {
    var next = hideEnded(document);
    var wait = next ? (next - Date.now() / 1000) * 1000 + 1000 : 0;
    if (wait > 0 && wait < 172800000) setTimeout(function () { hideEnded(document); }, wait);
    /* the bag and the product block are redrawn when the cart or the variant changes */
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) hideEnded(n); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* 5. Search panel (header magnifier): on computers it opens just below the header instead of over the logo
        (dt-type.css reads --dt-search-top), and when it was opened with a click or a tap, closing it leaves no
        focus box on the magnifier. Opened from the keyboard, the focus ring stays for keyboard users. */
  function searchPanel() {
    var modal = document.getElementById('search-modal');
    if (!modal || modal.dataset.dtWatched) return;
    modal.dataset.dtWatched = '1';
    var byPointer = false;
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('.search-modal__button')) byPointer = event.detail > 0;
    }, true);
    modal.addEventListener('dialog:open', function () {
      var dialog = modal.querySelector('dialog');
      var header = document.getElementById('header-component');
      if (!dialog || !header) return;
      var bottom = header.getBoundingClientRect().bottom;
      dialog.style.setProperty('--dt-search-top', Math.round(Math.max(0, bottom) + 12) + 'px');
    });
    modal.addEventListener('dialog:close', function () {
      var button = document.activeElement;
      if (!byPointer || !button || !button.classList || !button.classList.contains('search-modal__button')) return;
      button.classList.add('dt-no-ring');
      button.addEventListener('blur', function () { button.classList.remove('dt-no-ring'); }, { once: true });
    });
  }

  /* 6. Hero and slideshow videos: each <source> carries media="" (sections/hero.liquid, blocks/_slide.liquid),
        so a phone only downloads the phone video and a computer only the computer video. When the screen
        crosses 750px (a phone turned sideways, a window resized), the video that now shows loads and plays. */
  function watchGatedVideos() {
    var mq = window.matchMedia('(min-width: 750px)');
    function sync() {
      document.querySelectorAll('video').forEach(function (video) {
        var source = video.querySelector('source[media]');
        if (!source || video.currentSrc) return;
        if (window.matchMedia(source.media).matches) video.load();
      });
    }
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
  }

  /* 7. Product photos: on the product page (and in quick add) the gallery's first photo loads first; the other
        slides are marked lazy so they don't compete with it, and are fetched as soon as the page has loaded,
        so they are ready before the shopper swipes. A touch on the gallery fetches them too. Hidden galleries
        (the phone slideshow on a computer) are left alone and never downloaded. */
  function loadSlides(root) {
    (root || document).querySelectorAll('media-gallery > slideshow-component img.product-media__image[loading="lazy"]').forEach(function (img) {
      if (img.getClientRects().length) img.loading = 'eager';
    });
  }
  function watchSlides() {
    function ready() {
      loadSlides();
      new MutationObserver(function (list) {
        list.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType === 1 && (n.closest('media-gallery') || n.querySelector('media-gallery'))) setTimeout(loadSlides, 0);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
    if (document.readyState === 'complete') ready();
    else window.addEventListener('load', ready, { once: true });
    document.addEventListener('pointerdown', function (event) {
      var gallery = event.target.closest && event.target.closest('media-gallery');
      if (gallery) loadSlides(gallery);
    }, { passive: true, capture: true });
  }

  function start() {
    scan();
    watchEnds();
    searchPanel();
    watchGatedVideos();
    watchSlides();
    /* the app draws its row a little after the page loads */
    if (!watchInstagram()) {
      var tries = 0;
      var t = setInterval(function () { if (watchInstagram() || ++tries > 20) clearInterval(t); }, 500);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
